import animation from './ts/animation'
import cookie from './ts/cookie'
import fancybox from './ts/fancybox'
import inputs from './ts/inputs'
import loadMedia from './ts/load-media'
import phoneMask from './ts/phone-mask'
import preloader from './ts/preloader'
import submitHandler from './ts/submit-handler'
import waved from './ts/waved'

import '@fancyapps/ui/dist/fancybox/fancybox.css'
import './scss/main.scss'

window.addEventListener('DOMContentLoaded', ((): void => {
  animation()
  cookie()
  fancybox()
  inputs()
  phoneMask()
  submitHandler()
  waved()
  preloader()
}) as EventListener)

window.addEventListener('load', loadMedia as EventListener)
